import * as React from 'react';

import { StepsPanel } from '../StepsPanel';
import { Alert, AlertStatus } from '../Alert';
import { Input } from '../Input';
import { InputType } from '../Input/Input.types';
import { ShopifyProductVariant } from '../../utils/interfaces';

interface QuantitySelectionProps {
    step: number;
    quantity: number | "";
    minQuantity: number;
    onBlur: (e: KeyboardEvent) => void;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    selectedVariant: ShopifyProductVariant;
}

export const QuantitySelection = ({
    step,
    quantity,
    minQuantity,
    onBlur,
    onChange,
    selectedVariant,
}: QuantitySelectionProps) => {
    
    const renderDeliveryMsg = (): JSX.Element => {
        const selectedStockLevel = selectedVariant.inventory_quantity;
        if (!isNaN(quantity as number) && ((quantity as number) > selectedStockLevel && selectedStockLevel > 0)) {
            return (
                <Alert status={AlertStatus.Warning}>
                    Stock limit exceeded. 3 week delivery time.
                </Alert>
            )
        }
        return null;
    };

    const renderMinQuantity = (): JSX.Element => {
        if (minQuantity > 1) {
            <Alert status={AlertStatus.Warning}>
                New Title Badges have a minimum order quantity of {minQuantity}
            </Alert>
        }
        return null;
    };

    return (
        <StepsPanel
            title="Select your quantity"
            step={step++}
        >
            {renderMinQuantity()}
            {renderDeliveryMsg()}
            <Input
                name="tb-quantity"
                min={minQuantity}
                label="Quantity"
                labelHidden
                type={InputType.Number}
                value={quantity}
                onBlur={onBlur}
                onChange={onChange}
            />
            
        </StepsPanel>
    )
};